import { render, staticRenderFns } from "./AllNews.vue?vue&type=template&id=5f4222a4&scoped=true"
import script from "./AllNews.vue?vue&type=script&lang=js"
export * from "./AllNews.vue?vue&type=script&lang=js"
import style0 from "./AllNews.vue?vue&type=style&index=0&id=5f4222a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4222a4",
  null
  
)

export default component.exports